import { cn } from '@/lib/utils';

function Skeleton({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn('animate-pulse rounded-ds-004 bg-silver-200', className)}
      {...props}
    />
  );
}

export { Skeleton };
